<template>
    <div
        v-spinner="loading"
        class="qq-config-tab-page"
    >
        <v-spinner
            :offset-y="300"
            size="large"
        />
        <qq-config-open-detail
            ref="openDetailRef"
            :company-info-data="companyInfoData"
            @getNowData="getNowData"
            @getCompanyInfoData="getCompanyInfoData"
        />
        <div class="qq-config-tab-page__chat-detail" />
        <div class="button-line">
            <v-button
                :disabled="isReady"
                @click="saveAndPublish"
                status="primary"
                class="save-btn"
            >
                保存并发布
            </v-button>
            <v-button
                @click="initData"
                class="cancel-btn"
            >
                取消
            </v-button>
        </div>
    </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import QqConfigOpenDetail from './qq-config-open-detail/index';
import { isSameObj } from '../web-tab-detail/config';

export default {
    components: {
        QqConfigOpenDetail,
    },
    data() {
        return {
            loading: true,
            isReady: true,
            cacheData: {},
            companyInfoData: {},
        };
    },
    mounted() {
        window.addEventListener(
            'beforeunload',
            (e) => {
                if (!this.isReady) {
                    const confirmationMessage = '您的编辑可能未保存，是否离开';
                    (e || window.event).returnValue = confirmationMessage; // Gecko and Trident
                    return confirmationMessage;
                }
                return e;
            },
            false
        );
        this.fetchData();
    },
    methods: {
        fetchData() {
            this.loading = true;
            this.$ajax
                .get('/tp/IMAccessSet/getQQCoversationInfo')
                .then((res) => {
                    if (+res.code === 0) {
                        this.loading = false;
                        this.isReady = true;
                        // 存储一份数据
                        this.cacheData = cloneDeep(res.data);
                        this.initData();
                    } else {
                        this.$message.error(res.msg || '发生错误，请刷新重试');
                    }
                })
                .catch((err) => {
                    this.$message.error(err.msg || '发生错误，请刷新重试');
                });
        },
        getCompanyInfoData(data) {
            this.guidanceInfoData = cloneDeep(data);
        },
        // 获取当前的数据
        getNowData(data, type) {
            this.nowData = {
                ...this.nowData,
                [type]: cloneDeep(data),
            };
            this.isReady = isSameObj(this.nowData, this.cacheData);
        },
        // 保存当前数据
        saveAndPublish() {
            this.$refs.openDetailRef.saveData();
            const paramsObj = {};
            paramsObj.companyInfoData = cloneDeep(this.companyInfoData);
            delete paramsObj.companyInfoData.companyAddress;
            delete paramsObj.companyInfoData.companyEmail;
            delete paramsObj.companyInfoData.companyIntro;
            delete paramsObj.companyInfoData.companyLogo;
            delete paramsObj.companyInfoData.companyName;
            delete paramsObj.companyInfoData.companyPhone;
            delete paramsObj.companyInfoData.companySignature;
            delete paramsObj.companyInfoData.companySite;
            delete paramsObj.companyInfoData.companyShowCaseImg;
            if (paramsObj.companyInfoData.recommendation) {
                paramsObj.companyInfoData.recommendation = paramsObj.companyInfoData.recommendation.map(item => ({ value: item.key, type: item.type }));
            }
            this.$ajax
                .post('/tp/IMAccessSet/setQQCoversationInfo', {
                    ...paramsObj,
                })
                .then((res) => {
                    if (res.code === 0) {
                        this.isReady = true;
                        this.$message.success('保存成功并发布');
                        // 保存成功之后默认数值发生改变
                        this.cacheData = cloneDeep(this.nowData);
                    } else {
                        this.$message.error(res.msg || '保存失败');
                    }
                })
                .catch((err) => {
                    this.$message.error(err.msg || '发生错误，请刷新重试');
                });
        },
        // 取消按钮
        initData() {
            this.companyInfoData = cloneDeep({
                ...this.cacheData.companyInfoData,
            });
        },
    },
};
</script>

<style lang="less">
@import './style.less';
</style>
